import ActionArea from './action-area';

export default ActionArea;
